
import React, { Component } from 'react';
import { SketchPicker } from 'react-color';

export default class ColorSet extends Component {
    constructor(props, context) {
        super(props, context);
        this.state = {
            visibleKey: '',
            elementId: 'color-editor' + Math.random().toString().substring(3),
            // colors: props.colors || []
            // colors: []
        }
    }
    componentDidMount() {
        this._blankClick = this.blankClick.bind(this);
        document.addEventListener('click', this._blankClick);
    }

    componentWillReceiveProps(nextProps) {
        // if (nextProps.colors !== this.props.colors) {
        //     this.setState({ colors: nextProps.colors });
        // }

    }

    onChange(colors) {
        // this.setState({
        //     colors: colors
        // })
        this.props.onChange && this.props.onChange([...colors]);
    }

    showPicker(index) {
        this.setState({
            visibleKey: index
        })
    }
    blankClick(e) {
        if (this.isBlank(e.target)) {
            this.setState({
                visibleKey: -1
            });
        }
    }
    isBlank(node) {
        if (node) {
            if ((node.id || '').indexOf(this.state.elementId) > -1) {
                return false;
            } else {
                return this.isBlank(node.parentNode)
            }
        } else {
            return true;
        }
    }
    componentWillUnmount() {
        document.removeEventListener('click', this._blankClick);
    }
    render() {
        let { visibleKey } = this.state;
        let colors = this.props.colors;
        let onlyDisplay = this.props.onlyDisplay;
        return (
            <div style={{
                position: 'relative',
                lineHeight: 0
            }}>
                {
                    colors.map((color, index) => {
                        return <div key={index} id={this.state.elementId + index} className="freesia-color-editor" style={{

                            height: '100%',
                            marginTop: 4,
                            display: 'inline-block',
                            ...this.props.style
                        }}>
                            <div style={{
                                width: "30px",
                                // border: "1px solid #ddd",
                                height: "30px",
                                position: "relative",
                                ...this.props.colorStyle
                            }} onClick={e => this.showPicker(index)}>
                                <div style={{
                                    position: "absolute",
                                    top: "1px",
                                    left: "1px",
                                    bottom: "1px",
                                    right: "1px",
                                    background: color
                                }}>

                                </div>
                            </div>
                            {onlyDisplay ? null : <div style={{ display: `${visibleKey === index ? "block" : "none"}` }}>
                                <SketchPicker className="color-set-selector" styles={{
                                    top: 'unset'
                                }} color={color} onChange={result => {
                                    let color = `rgba(${result.rgb.r},${result.rgb.g},${result.rgb.b},${result.rgb.a})`;
                                    colors[index] = color;
                                    this.onChange(colors);
                                }} />
                            </div>}
                        </div>
                    })}
            </div>

        );
    }
}
